<template>
  <div class="content md">
    <system-admin type="tablet"></system-admin>
  </div>
</template>

<script>
import SystemAdmin from "../../layouts/SystemAdmin";
export default {
  name: "TabletAdmin",
  components: {
    SystemAdmin,
  },
};
</script>

<style scoped></style>
